import { render, staticRenderFns } from "./view-locking.vue?vue&type=template&id=0d206298&"
import script from "./view-locking.vue?vue&type=script&lang=ts&"
export * from "./view-locking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports